import React from 'react';
import {WeaSearchGroup, WeaFormItem, WeaInput} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import EShowNum from './base/EShowNum';
import ELinkMode from './base/ELinkMode';
//import EField from './base/EField';
import EField_New from './base/EField_New'
import ENewsMould from './base/ENewsMould';
import ERemindMode from './base/ERemindMode';

// 多新闻中心
export default class Content_17 extends React.Component {
    state = {
        eNewsPageId: this.props.eNewsPageId,
        eNewsMoreAddress: this.props.eNewsMoreAddress,
        eFieldNewDataSource: this.props.eFieldNewDataSource,
        eFieldNewUsedKeys: this.props.eFieldNewUsedKeys,
        eFieldNewVisible: false,
    };

    render() {
        const { eNewsPageId, eNewsMoreAddress, eFieldNewDataSource, eFieldNewUsedKeys, eFieldNewVisible } = this.state;

        let ENewsModule = <div></div>;
        let ENewsPageId = <div></div>;
        let ENewsMoreAddress = <div></div>;
        if (this.props.eShareLevel == '2') {
            ENewsModule = <ENewsMould ecId={`${this && this.props && this.props.ecId || ''}_ENewsMould@4j3rsh`} ref="eNewsMould" options={this.props.eNewsMould.options} value={this.props.eNewsMould.selected}/>;
            ENewsPageId = (
                <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@49q82p`} label={getLabel(386561, '新闻页ID')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@qsjg8o`} value={eNewsPageId} style={{width: '80%'}} onChange={value => this.setState({eNewsPageId: value})}/>
                    <div>{getLabel(386562, '多新闻页请用半角分号分开。如（1;2）')}</div>
                </WeaFormItem>
            );
            ENewsMoreAddress = (
                <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@2lqaim`} label={getLabel(386563, 'More地址')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <WeaInput ecId={`${this && this.props && this.props.ecId || ''}_WeaInput@1f8a59`} value={eNewsMoreAddress} style={{width: '80%'}} onChange={value => this.setState({eNewsMoreAddress: value})}/>
                </WeaFormItem>
            );
        }

        let EFieldNewshow = <div></div>;
        let EFieldNew = <div></div>;
        if (eFieldNewVisible) {
            const eFieldNewProps = {
                eFieldNewDataSource: _.cloneDeep(eFieldNewDataSource),
                eFieldNewUsedKeys: _.cloneDeep(eFieldNewUsedKeys),
                onOk: (data) => {
                    this.setState({
                        eFieldNewDataSource: _.cloneDeep(data.eFieldNewDataSource),
                        eFieldNewUsedKeys: _.cloneDeep(data.eFieldNewUsedKeys),
                        eFieldNewVisible: false
                    });
                },
                onCancel: () => {
                    this.setState({
                        eFieldNewVisible: false
                    });
                }
            };
            EFieldNewshow = (
                <EField_New ecId={`${this && this.props && this.props.ecId || ''}_EField_New@3l04sr`} {...eFieldNewProps}/>
            );
        }
        const eFieldNewUsedNames = [];
        for (let i = 0; i < eFieldNewUsedKeys.length; i++) {
            for (let j = 0 ; j < eFieldNewDataSource.length; j++) {
                if (eFieldNewUsedKeys[i] == eFieldNewDataSource[j].key) {
                    eFieldNewUsedNames.push(eFieldNewDataSource[j].name);
                }
            }
        }
        
        EFieldNew = this.props.eShareLevel == '2' ? (
            <WeaFormItem ecId={`${this && this.props && this.props.ecId || ''}_WeaFormItem@60i7ar`} label={getLabel(19495, '显示字段')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                {EFieldNewshow}
                <div style={{height: '30px', lineHeight: '23px'}}>
                    <i className="icon-coms-Flow-setting portal-esetting-btn" onClick={() => this.setState({eFieldNewVisible: true})}/>
                    <span>{eFieldNewUsedNames.join('，')}</span>
                </div>
            </WeaFormItem>
        ) : '';

        return (
            <div>
                <WeaSearchGroup ecId={`${this && this.props && this.props.ecId || ''}_WeaSearchGroup@39cxjv`} title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ecId={`${this && this.props && this.props.ecId || ''}_EType@a5og1x`} ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ecId={`${this && this.props && this.props.ecId || ''}_ETitle@cfsjql`} ref="eTitle" eid={this.props.eid} value={this.props.eTitle} {...this.props}/> : ''}
                    <EShowNum ecId={`${this && this.props && this.props.ecId || ''}_EShowNum@79k0js`} ref="eShowNum" value={this.props.eShowNum}/>
                    <ELinkMode ecId={`${this && this.props && this.props.ecId || ''}_ELinkMode@mchrw8`} ref="eLinkMode" options={this.props.eLinkMode.options} value={this.props.eLinkMode.selected}/>
                    {/*<EField ref="eField" value={this.props.eField}/>*/}
                    {EFieldNew}
                    {ENewsModule}
                    {ENewsPageId}
                    {ENewsMoreAddress}
                    <ERemindMode ecId={`${this && this.props && this.props.ecId || ''}_ERemindMode@ki1bml`} ref="eRemindMode" value={this.props.eRemindMode}/>
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentShowNum: this.refs['eShowNum'].getSaveValues(),
            eContentLinkMode: this.refs['eLinkMode'].getSaveValues(),
            eContentFieldNewUsedKeys: this.state.eFieldNewUsedKeys,
            eContentNewsMould: this.refs['eNewsMould'].getSaveValues(),
            eContentNewsPageId: this.state.eNewsPageId,
            eContentNewsMoreAddress: this.state.eNewsMoreAddress,
            eContentRemindMode: this.refs['eRemindMode'].getSaveValues()
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_17.js